module.exports = __webpack_public_path__ + "static/media/jas.1128c67e.png";